import { Button, HeroLayout, Image, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useSapContainer } from './hooks/useSapContainer';

export const SapContainer: React.FC = () => {
	const {
		data: { sapImage, sapAiUrl, sapUrl },
		actions: { trackSapAiClick, trackSapClick },
	} = useSapContainer();

	return (
		<HeroLayout media={<Image src={sapImage} alt="" className="h-full w-full object-cover object-top" />} variant="1/2">
			{/*
				text-typography-inverse-strong-fixed (not the flipping text-typography-inverse-strong) is intentional here:
				bg-gradient-background-dark-1 is documented (Storybook TOKENS/Gradients) to only dim to ~69% alpha in dark
				mode while remaining the same blue gradient - it never becomes a light surface - so the heading text must
				stay fixed-white in both modes to keep reading against it.
			*/}
			<div className="bg-gradient-background-dark-1 text-typography-inverse-strong-fixed flex flex-col justify-center space-y-5 p-6 md:p-10">
				<Text as="h2" variant="heading" className="mb-1">
					<Translate value="corgi.impact_story.cta.title" />
				</Text>

				<Button
					as="a"
					data-testid="impact-story-page-sap"
					data-qa="impact-story-page-sap"
					href={sapUrl}
					variant="primary"
					size="small"
					onClick={trackSapClick}
				>
					<Translate value="corgi.impact_story.cta.primary_button" />
				</Button>
				<Button
					as="a"
					data-testid="impact-story-page-sap-ai"
					data-qa="impact-story-page-sap-ai"
					href={sapAiUrl}
					variant="secondary-inverse"
					size="small"
					onClick={trackSapAiClick}
					className="dark:before:border-stroke-strong dark:outline-stroke-strong!"
				>
					<Translate value="corgi.impact_story.cta.secondary_button" />
				</Button>
			</div>
		</HeroLayout>
	);
};
